import React from 'react';

import UpcomingChangeIcon from './UpcomingChangeIcon';

import { Interest } from '../../../../../Interface/Response/Interest/Interest';

import { formatPercent } from '../../../../../Helpers/Percent';

interface Props {
    interest: Interest;
    prefix?: string;
}

const InterestCell: React.FC<Props> = ({ interest, prefix = '' }: Props) => (
    <div className="percent-cell summary">
        {prefix}<span>{formatPercent(interest.percentage as string)}</span>
        <UpcomingChangeIcon change={interest.upcomingChange} />
    </div>
);

export default InterestCell;
